export default __webpack_public_path__ + "static/media/userInfoActive.a46ae599.svg";